import { THEME_LABEL_BY_VALUE } from './constants';
/**
 * 선택된 시군구 group id 목록을 chip 데이터로 변환.
 */
export function regionsToChips(selectedRegionIds, labelMap) {
    return selectedRegionIds.map(id => { var _a; return ({ id, label: (_a = labelMap[id]) !== null && _a !== void 0 ? _a : id }); });
}
/**
 * 선택된 관심 테마 목록을 chip 데이터로 변환.
 */
export function themesToChips(selectedThemes) {
    return selectedThemes.map(theme => ({
        id: theme,
        label: THEME_LABEL_BY_VALUE[theme],
    }));
}
/**
 * 두 배열이 set으로 동등한지 비교. 폼 변경 여부 판단에 사용한다.
 */
export function arraysEqualAsSets(a, b) {
    if (a.length !== b.length) {
        return false;
    }
    const setB = new Set(b);
    return a.every(item => setB.has(item));
}
